/** @jsxImportSource @emotion/react */

import { WarningFilled } from "@ant-design/icons";

import { NodataStyle } from "./style.index";

const Nodata = () => {
  return (
    <div css={NodataStyle.wrapper}>
      <WarningFilled />
      <span> Không có bất kỳ thông tin nào</span>
    </div>
  );
};

export default Nodata;
